import { useRequest } from 'ahooks'
import { Message } from '@/components/message'
import { getAuthorizeConfig, updateAuthorize } from '@/api/account-center/authorize-manage'
import { getAuthTime } from '@/api/login'
import { t } from '@/i18n'

// 获取授权配置
export const useGetAuthorizeConfig = () => {
  const { data, runAsync: run } = useRequest(() => getAuthorizeConfig(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取授权配置失败'))
    },
  })

  return [data?.data, run] as const
}

// 获取授权时间
export const useGetAuthTime = () => {
  const { runAsync: run, data } = useRequest(() => getAuthTime(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取授权时间失败'))
    },
  })
  return [run, data?.data || []] as const
}

// 更新授权
export const useUpdateAuthorize = () => {
  const { runAsync: run, loading } = useRequest((params: any) => updateAuthorize(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('更新授权失败'))
    },
  })
  return [run, loading] as const
}
